import React from 'react';
//import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useMediaQuery from '@mui/material/useMediaQuery';
import Paper from '@mui/material/Paper';
import {Owner} from './Inc';
import useStyles from './Styles';
import Ajax from './Ajax';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import BottomButtons from './BottomButtons';
import {Theme} from './Theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faDownload,faFilePdf,faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

interface Props {
	isOpen:boolean,
    owner:Owner,
    sheetId:number,
    close(): void,
}

const LetterDownload = (props:Props)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));
    library.add(faDownload,faFilePdf,faQuestionCircle);

    const download = ()=>{
        Ajax.download("letter/download",{filename:'納品書'+props.sheetId,sheet_id:props.sheetId},(res:any)=>{
            if( res.ok ){
                //console.log("ok");
            }
        });
    }

	if(!props.isOpen){
		return (null);
	}

	return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}
			fullScreen={fullScreen}
		>
			<DialogTitle color='primary'>納品書のダウンロード</DialogTitle>
			<DialogContent dividers>
				<Paper style={{padding:"1em",paddingBottom:"2em",textAlign:"center",marginBottom:"2em",cursor:"pointer"}} onClick={download}>
					<p style={{fontSize:"90%"}}>納品書を作成しました</p>
					<p className={classes.primary}><FontAwesomeIcon icon="file-pdf" style={{fontSize:"300%"}}/></p>
					<FontAwesomeIcon icon="download"/> ダウンロード
				</Paper>
				<div className={classes.confirmGuide}>
					PDFをダウンロードしたらプリンターで印刷し、商品に同封してください。<br/>
					<div style={{marginTop:'1em',marginBottom:'4em',fontSize:'90%',color:'brown'}}>
						※納品時の注意事項や納品先の住所は納品書に記載されていますが、わからないところがある場合はご利用ガイドの「納品のハウツー」も参考にしてみてください。
					</div>
					<div style={{fontSize:"90%",padding:"1em",border:"1px solid silver",marginBottom:'1em'}}>
						<div className={classes.primary}><FontAwesomeIcon icon="question-circle"/> 追跡番号を登録しましょう</div>
						<div>荷物の発送が済みましたら、納品の履歴から荷物の追跡番号をお知らせしていただくと手続きがスムーズになります</div>
					</div>
					<div style={{fontSize:"90%",padding:"1em",border:"1px solid silver"}}>
						<div className={classes.primary}><FontAwesomeIcon icon="question-circle"/> PDFがうまくいかない？</div>
						<div>PDFが出力されない、出力はされたけど開けないなど、どうしてもPDFの納品書で作成できない場合は、「出力しないで納品」を選んでみてください。</div>
					</div>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='閉じる' onClick1={props.close} top={0} bottom={0}/>
			</DialogActions>
        </Dialog>
	);
}

export default LetterDownload;
